import { render, staticRenderFns } from "./Αctivereserve.vue?vue&type=template&id=65ef6dba"
import script from "./Αctivereserve.vue?vue&type=script&lang=js"
export * from "./Αctivereserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports